import handleError from 'common/helpers/handleError';
import { mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('dashboard', ['isCopied']),
    ...mapState('app', ['account']),
    canCopyFormEmbedCode() {
      return this.account.capabilities.canCopyFormEmbedCode;
    },
  },
  methods: {
    ...mapMutations('dashboard', ['setCopied']),
    async copyCode(code) {
      if (this.isCopied) {
        return;
      }
      try {
        await navigator.clipboard.writeText(code);
        this.setCopied(true);
        setTimeout(() => {
          this.setCopied(false);
        }, 2000);
      } catch (error) {
        handleError(error);
      }
    },
  },
};
